import { atom } from "recoil";

type TDefaultLoginFormState = {
    open: boolean;
    type: null | "login" | "company" | "custom";
    id: string;
    pwd: string;
    lcm: boolean;
    coTin: string;
    coTpCd: string;
    coCd: string;
    coTpList: any[];
    cstmCd: string;
    usrCstmList: any[];
    loading: boolean;
};

export const defaultLoginFormState: TDefaultLoginFormState = {
    open: false,
    type: "login",
    id: "",
    pwd: "",
    lcm: false,
    coTin: "",
    coTpCd: "",
    coCd: "",
    coTpList: [],
    cstmCd: "",
    usrCstmList: [],
    loading: false,
};
const loginFormState = atom<TDefaultLoginFormState>({
    key: "loginFormState",
    default: defaultLoginFormState,
});

export default loginFormState;
